

app.filter('_validToFilter', function($filter){
    return function(value, fromDate) {
           
        //to end of workflow   
        if (/obsługi/.test(value))
        return value;    
           
        if (/7 dni/.test(value)){
         
           //7 days after
           return $filter('_date')(moment(fromDate).add(7, 'days'));
            
        }
        
        //normal date
        return $filter('_date')(value);
        

    };
});
